import { render, staticRenderFns } from "./MutabakatRaporu.vue?vue&type=template&id=55196725&"
import script from "./MutabakatRaporu.vue?vue&type=script&lang=js&"
export * from "./MutabakatRaporu.vue?vue&type=script&lang=js&"
import style0 from "./MutabakatRaporu.vue?vue&type=style&index=0&id=55196725&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports